const rejson = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/;

export function isNumber(num) {
  var number = +num;

  if ((number - number) !== 0) {
    // Discard Infinity and NaN
    return false;
  }

  if (number === num) {
    return true;
  }

  if (typeof num === 'string') {
    // String parsed, both a non-empty whitespace string and an empty string
    // will have been coerced to 0. If 0 trim the string and see if its empty.
    if (number === 0 && num.trim() === '') {
      return false;
    }
    return true;
  }
  return false;
};

export function hyphenToCamelCase(hyphen) {
  return hyphen.replace(/-([a-z])/g, function(match) {
    return match[1].toUpperCase();
  });
}

export function camelCaseToHyphen(camelCase) {
  return camelCase.replace(/[A-Z]/g, '-$1').toLowerCase();
}

export function attributeToCamelCase(attribute) {
  return hyphenToCamelCase(attribute.replace(/^(data-)?(.*)/, '$2'));
}

export function camelCaseToAttribute(camelCase) {
  return 'data-' + camelCaseToHyphen(camelCase);
}

export function stringToCamelCase(string) {
  return string.replace(/(?:^\w|[A-Z]|\b\w)/g, function(letter, index) {
    return index == 0 ? letter.toLowerCase() : letter.toUpperCase();
  }).replace(/\s+/g, '');
}

export class DataAttrParser {
  /**
   * @param {DOMStringMap} dataset
   * @param {Array<String>} _prefixes
   */
  static parse(dataset, _prefixes = []) {
    let result = {};
    const keys = Object.keys(dataset);
    const grouping = _prefixes.length;
    const prefixes = _prefixes.map(hyphenToCamelCase);

    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      let value = dataset[key];

      if (value === 'true') {
        result[key] = true;
        continue;
      }

      if (value === 'false') {
        result[key] = false;
        continue;
      }

      if (isNumber(value)) {
        result[key] = Number(value);
        continue;
      }

      if (value === 'null') {
        result[key] = null;
        continue;
      }

      if (rejson.test(value)) {
        result[key] = JSON.parse(value);
        continue;
      }

      // @String
      result[key] = value;
    }

    // Group result object
    prefixes.forEach(prefix => {
      let subResult = {};

      Object.keys(result)
        .filter(key => key.startsWith(prefix))
        .forEach(key => {
          let slicedKey = stringToCamelCase(key.replace(prefix, ''));
          if (slicedKey === '') slicedKey = prefix;
          subResult[slicedKey] = result[key];
          delete result[key];
        });

      result[prefix] = subResult;
    });

    return result;
  }
}
